import React, { useState, useEffect, memo } from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';



import moment from 'moment';

import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import Pagination from '@mui/material/Pagination';



const PageNav = ({ pages, active, bottom }) => {



  const useCustomSearchParams = () => {
    const [search, setSearch] = useSearchParams();
    const searchAsObject = Object.fromEntries(
      new URLSearchParams(search)
    );

    return [searchAsObject, setSearch];
  };

  const [search] = useCustomSearchParams();


  const query = search.q
  let page = search.p

  if (page === undefined) {
    page = 1
  }




  //const [query, setQuery] = useState('');
  const navigate = useNavigate()


  function replaceUrlParam(url, paramName, paramValue) {
    if (paramValue == null) {
      paramValue = '';
    }
    var pattern = new RegExp('\\b(' + paramName + '=).*?(&|#|$)');
    if (url.search(pattern) >= 0) {
      return url.replace(pattern, '$1' + paramValue + '$2');
    }
    url = url.replace(/[?#]$/, '');
    return url + (url.indexOf('?') > 0 ? '&' : '&') + paramName + '=' + paramValue;
  }

  let url = window.location.search


  function navTo(page) {

    
    navigate(replaceUrlParam(url, "p", page));

    if (bottom === true) {
      window.scrollTo(0, 0);
    }
  }

  function handlePagination (event, value) {
    navTo(value)
  }


  return (
    <Pagination count={parseInt(pages)} defaultPage={parseInt(active)} onChange={handlePagination} />
  );
};



export default PageNav